// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"pf","landingPageVideo":"qf","play":"rf","iframeVideo":"sf","playHidden":"tf","playVisible":"uf","fullwidth":"vf"};